export default __webpack_public_path__ + "static/media/back_button.78d5b6ff.svg";